import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Equipment",
  layout: {
    type: "customCase010204",
    options: {
      page1: {
        imageDescription: "Cabin without panel seen from outside",
        image: `${config.ASSETS_URL}/01/case-02/slide04-image01.svg`,
      },
      page2: {
        image: `${config.ASSETS_URL}/01/case-02/slide04-image02.svg`,
      },
      page3: {
        imageDescription: "Standard source for absolute pressure calibration",
        image: `${config.ASSETS_URL}/01/case-02/slide04-image03.svg`,
      },
      page4: {
        imageDescription:
          "Coupling cavity with source for the two-microphone<br>relative calibration of the tandem intensity probe",
        image: `${config.ASSETS_URL}/01/case-02/slide04-image04.svg`,
      },
    },
  },
};

export default principle;
